import swal from './swal';

// Must stay below the API's nginx client_max_body_size / PHP post_max_size:
// base64 encoding inflates the request body by ~33%
export const MAX_BLOCKING_FILE_BYTES = 5 * 1024 * 1024;

const ALLOWED_TYPES = ['image/jpeg', 'application/pdf'];

const MEGABYTE = 1024 * 1024;

/** Rejection reason for a blocking-list attachment, or null when the file is acceptable */
export const blockingFileError = file => {
  if (!file) return 'لم يتم اختيار ملف';
  if (!ALLOWED_TYPES.includes(file.type)) {
    return 'صيغة الملف غير مدعومة، يرجى ارفاق صورة JPEG أو ملف PDF';
  }
  if (file.size > MAX_BLOCKING_FILE_BYTES) {
    return `حجم الملف يتجاوز الحد المسموح (${MAX_BLOCKING_FILE_BYTES / MEGABYTE} ميجابايت)`;
  }
  return null;
};

/** Validates an attachment before upload, showing the reason when it is rejected */
export const isValidBlockingFile = file => {
  const error = blockingFileError(file);
  if (error) swal.fire({ title: 'عذرا', text: error, type: 'warning' });
  return !error;
};

/**
 * Extracts the raw base64 payload from a FileReader data URL.
 * The API strips a `data:<mime>;` prefix of its own, so sending the full data URL
 * leaves a `base64,` fragment glued to the payload and decodes to a corrupt file.
 */
export const toBase64Payload = dataUrl => dataUrl.slice(dataUrl.indexOf(',') + 1);
